"use strict";
import * as e from './echart_utils.js';
var currentTheme = localStorage.getItem('theme') || 'light';

// General part
var chartsConfig = update_chartsConfig(currentTheme);

function update_chartsConfig(currentTheme) {
  chartsConfig = [
    {
      elementId: 'chart_polkadot_staking_rate',
      csvPath: 'data/eoyr_shared_security_sum_of_stake_pct_staked000000000000.csv',
      build: e.staking_rate
    },
    {
      elementId: 'chart_polkadot_nominators_validators',
      csvPath: 'data/eoyr_shared_security_number_of_nominators000000000000.csv',
      build: e.nominators_validators
    },
    {
      elementId: 'chart_polkadot_nakamoto_coefficient',
      csvPath: 'data/eoyr_shared_security_nakamoto_coefficient000000000000.csv',
      build: e.nakamoto_coefficient
    },
    {
      elementId: 'chart_polkadot_min_max_validator_stakes',
      csvPath: 'data/eoyr_shared_security_difference_between_minimum_and_maximum_validator_stake000000000000.csv',
      build: e.min_max_nominators_validators_stake
    },
    {
      elementId: 'chart_polkadot_treasury_balance',
      csvPath: 'data/eoyr_governance_treasury_balance000000000000.csv',
      build: e.treasury_balance
    },
    {
      elementId: 'chart_polkadot_treasury_flows',
      csvPath: 'data/eoyr_governance_treasury_flows000000000000.csv',
      build: e.treasury_flows
    },
    {
      elementId: 'chart_opengov_number_of_referenda_by_outcome',
      csvPath: 'data/eoyr_governance_number_of_referenda_by_outcome_opengov_history000000000000.csv',
      build: e.referenda_by_outcome_history
    },
    {
      elementId: 'chart_number_of_referenda_by_origin',
      csvPath: 'data/eoyr_governance_number_of_referenda_by_origin_opengov000000000000.csv',
      build: e.number_referenda_by_origin
    },
    {
      elementId: 'chart_number_of_votes_by_duration_of_lock',
      csvPath: 'data/eoyr_governance_number_of_votes_by_duration_of_lock_opengov000000000000.csv',
      build: e.number_of_votes_by_duration_of_lock
    },
    {
      elementId: 'chart_monthly_opengov_monthly_participation',
      csvPath: 'data/eoyr_governance_monthly_participation000000000000.csv',
      build: e.monthly_participation
    },
    {
      elementId: 'chart_monthly_opengov_number_of_voters',
      csvPath: 'data/eoyr_governance_number_of_voters000000000000.csv',
      build: e.monthly_number_of_voters
    },
    {
      elementId: 'chart_monthly_opengov_capital_by_type_no_conviction',
      csvPath: 'data/eoyr_governance_monthly_capital_by_type_no_conviction_direct_and_delegated_tokens_breakdown_no_conviction_opengov000000000000.csv',
      build: e.monthly_capital_no_conviction
    },
    {
      elementId: 'chart_monthly_opengov_voting_power_by_type_with_conviction',
      csvPath: 'data/eoyr_governance_monthly_voting_power_by_type_conviction_-_direct_and_delegated_tokens_breakdown_w_conviction_opengov000000000000.csv',
      build: e.monthly_voting_power_with_conviction
    },
    {
      elementId: 'chart_monthly_tokens_voted_by_direction_no_conviction',
      csvPath: 'data/eoyr_governance_number_of_tokens_by_vote_direction_no_conviction_opengov000000000000.csv',
      build: e.number_monthly_tokens_voted_by_direction
    },
    {
      elementId: 'chart_monthly_tokens_voted_by_direction_with_conviction',
      csvPath: 'data/eoyr_governance_number_of_tokens_by_vote_direction_w_conviction_opengov000000000000.csv',
      build: e.number_monthly_tokens_voted_by_direction
    },
    {
      elementId: 'chart_polkadot_number_of_parachains',
      csvPath: 'data/eoyr_parachains_number_of_parachains000000000000.csv',
      build: e.number_of_parachains
    },
    {
      elementId: 'chart_polkadot_monthly_transactions',
      csvPath: 'data/eoyr_parachains_number_of_transactions_extrinsics000000000000.csv',
      freq: 'monthly',
      relay: 'polkadot',
      yName: 'combined',
      title: 'Transactions (Substrate + EVM)',
      topN: 50,
      build: e.barchart
    },
    {
      elementId: 'chart_polkadot_unique_addresses',
      csvPath: 'data/eoyr_parachains_number_of_unique_addresses000000000000.csv',
      freq: 'monthly',
      relay: 'polkadot',
      yName: 'number_of_unique_addresses',
      title: 'Unique Addresses',
      topN: 50,
      build: e.barchart
    },
    {
      elementId: 'chart_polkadot_active_addresses',
      csvPath: 'data/eoyr_parachains_number_of_active_addresses000000000000.csv',
      freq: 'monthly',
      relay: 'polkadot',
      yName: 'combined',
      title: 'Active Addresses',
      build: e.barchart
    },
    {
      elementId: 'chart_xcm_sent_monthly_by_type',
      csvPath: 'data/eoyr_xcm_messages_by_type000000000000.csv',
      freq: 'monthly',
      relay: 'polkadot',
      yName: 'method_count',
      grouping: 'msg_type',
      title: 'XCM Messages Sent',
      build: e.barchart
    },
    {
      elementId: 'chart_xcm_distinct_hrmp',
      csvPath: 'data/eoyr_parachains_number_of_hrmp_channels000000000000.csv',
      build: e.xcm_distinct_hrmp_channels
    },
    {
      elementId: 'chart_xcm_message_usage_per_month_hrmp_senders',
      csvPath: 'data/eoyr_xcm_parachain_message_usag_per_month_hrmp_senders000000000000.csv',
      freq: 'monthly',
      relay: 'polkadot',
      yName: 'method_count',
      title: 'HRMP Senders',
      build: e.barchart
    },
    {
      elementId: 'chart_stackexchange_user_growth',
      csvPath: 'data/eoyr_stack_exchange_user_growth000000000000.csv',
      build: e.stackexchange_user_growth
    },
    {
      elementId: 'chart_stackexchange_top_25_tags',
      csvPath: 'data/eoyr_stack_exchange_top_25_tags000000000000.csv',
      build: e.stackexchange_top_tags
    },
    {
      elementId: 'chart_stackexchange_activity_eoy',
      csvPath: 'data/eoyr_stack_exchange_activity000000000000.csv',
      build: e.stackexchange_activity_eoy
    },
  ];

  chartsConfig.forEach(config => {
    const chart = e.createEchartElement(config.elementId, currentTheme);
    if (chart) {
      e.loadCSVData(config.csvPath, (data) => {
        config.build(config, data, chart);
      });
    } else {
      console.error(`Failed to create chart for element ${config.elementId}`);
    }
  });
}

// Listen for DOM content loaded to initialize the chart and setup theme switching
document.addEventListener('DOMContentLoaded', () => {
  const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
  
  toggleSwitch.addEventListener('change', (e) => {
    currentTheme = e.target.checked ? 'dark' : 'light';
    localStorage.setItem('theme', currentTheme); 
    document.body.classList.toggle('dark-mode', currentTheme === 'dark');
    update_chartsConfig(currentTheme); 
  });

  if (localStorage.getItem('theme') === 'dark') {
    toggleSwitch.checked = true;
    document.body.classList.add('dark-mode');
  }
  update_chartsConfig(currentTheme);
});